import { useQuery } from '@tanstack/react-query';
import { useRouter } from 'next-translate-routes-multi-domain';
import { useEffect, useState } from 'react';
import { isEmpty } from 'lodash-es';
import { ProductItem } from '../types/api';
import { getProductDetails } from '../repository/products/products';

export function useProduct() {
  const { query, locale } = useRouter();
  const { machine_id } = query;

  // this state is a mix of the DB product and a Partial product sent by the preview CMS command

  const sku =
    machine_id && machine_id.toString().includes('_')
      ? machine_id.toString().split('_')[1]
      : '';

  const { data: product, isLoading } = useQuery(
    ['product', sku, locale],
    () => getProductDetails(sku, locale),
    {
      enabled: !!sku && !!locale,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      refetchInterval: 0,
      refetchIntervalInBackground: false,
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  const [productWithPreview, setProductWithPreview] = useState(product);

  useEffect(() => {
    const receiveMessage = (event: MessageEvent<{ product: ProductItem }>) => {
      const productPreview = event.data.product;
      if (!isEmpty(productPreview)) {
        if (productPreview.model && product) {
          setProductWithPreview({
            ...product,
            model: productPreview.model ?? product.model,
          });
        }
      }
    };
    window.addEventListener('message', receiveMessage);

    return () => {
      window.removeEventListener('message', receiveMessage);
    };
  }, [product]);

  return { product: productWithPreview ?? product, isLoading };
}
